/**
 * @author        sammy.dowds@zumper.com (Sammy Dowds)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   ExpandableLinkPack
 */

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@zcode-ui/shadz-ui'
import React, { forwardRef, useEffect, useState } from 'react'
import { LinkPackColumns, type LinkPackColumnsProps } from '../LinkPackColumns'

interface ExpandableLinkPackProps extends LinkPackColumnsProps {
  header: string
  useBorderBottom?: boolean
}

export const ExpandableLinkPack = forwardRef(
  (
    {
      isExpanded = true,
      header,
      useBorderBottom,
      ...LinkPackColumnsProps
    }: ExpandableLinkPackProps,
    ref?: React.Ref<HTMLDivElement>
  ) => {
    const [isMounted, setIsMounted] = useState(false)
    const forceExpanded = isExpanded && !isMounted

    useEffect(() => {
      setIsMounted(true)
    }, [])

    if (!LinkPackColumnsProps.links?.length) {
      return null
    }
    const borderProps = useBorderBottom ? 'border-b ' : 'border-t '

    return (
      <div data-testid="expandable-link-pack" ref={ref}>
        <Accordion
          collapsible
          data-testid="shadz-accordion"
          defaultValue={isExpanded ? 'expandable-link-pack' : undefined}
          key={forceExpanded ? -1 : 1}
          type="single"
        >
          <AccordionItem
            className={`border-gray-150 border-solid border-1 ${borderProps}`}
            value="expandable-link-pack"
          >
            <AccordionTrigger className="py-6 px-3">
              <h3 className="display20To24 line-clamp-2 text-left">{header}</h3>
            </AccordionTrigger>
            <AccordionContent
              className={`pb-5 px-3 ${forceExpanded ? 'block h-fit opacity-100' : ''}`}
            >
              <LinkPackColumns header={header} {...LinkPackColumnsProps} />
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    )
  }
)
